// Official statistics from Champions.pdf
// These values are the source of truth for the website

export const stats = {
  employees: 120,
  branches: 5,
  sports: 8,
  championships: 12,
  players: 10000,
  nationalTeamPlayers: 10,
  facilitySizeSquareMeters: 26000,
  yearsOfExcellence: 10, // Founded 2015
  internationalCampsChildren: 1500, // Children participated in international camps
  foundingYear: 2015,
  cancerAcademyYear: 2019,
  
  // Partner counts
  globalPartners: 3, // Real Madrid, Barcelona, Metrica Sports
  localPartnersCapacity: 40, // Can accommodate 40+ more
  
  // Milestones
  milestones: [
    { year: 2015, event: "Champions Academy Founded" },
    { year: 2017, event: "First Regional Championship Won" },
    { year: 2019, event: "Cancer Patient Academy Launched" },
    { year: 2020, event: "Partnership with Real Madrid Foundation" },
    { year: 2021, event: "7 Branches Established" },
    { year: 2022, event: "50th Championship Celebrated" },
    { year: 2023, event: "7,500 Active Players Milestone" },
  ]
};

export const statsDisplay = [
  { key: "employees", value: stats.employees, labelKey: "stats.employees" },
  { key: "branches", value: stats.branches, labelKey: "stats.branches" },
  { key: "sports", value: stats.sports, labelKey: "stats.sports" },
  { key: "championships", value: stats.championships, labelKey: "stats.championships" },
  { key: "players", value: stats.players, labelKey: "stats.players" },
  { key: "nationalTeamPlayers", value: stats.nationalTeamPlayers, labelKey: "stats.nationalTeamPlayers" },
];
